import RaceLeageInfo from './RaceLeageInfo';

export default RaceLeageInfo;
